import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface ILegalEntity {
  [key: string]: any
}

class LegalEntity extends Model<ILegalEntity> {
  static payrollCountries = ['es', 'fr']

  static countryDefaults = {
    es: 'es',
    fr: 'fr',
    mx: 'mx',
    br: 'br',
  }

  constructor(attr: ILegalEntity) {
    super(attr)
    makeObservable(this, {
      country: computed,
      currency: computed,
      isFranceLegalEntity: computed,
    })
  }

  static urlRoot() {
    return '/legal_entities'
  }

  get country(): string {
    return this.attributes.country
  }

  get currency(): string {
    return this.attributes.currency
  }

  get name(): string | undefined {
    return this.attributes.legal_name
  }

  get isFranceLegalEntity(): boolean {
    return this.attributes.country === 'fr'
  }

  get isItalianLegalEntity(): boolean {
    return this.attributes.country === 'it'
  }

  get main(): boolean {
    return this.attributes.main
  }
}

export default LegalEntity
